interface Props {
  render: () => JSX.Element;
}

const StepperItem = ({}: Props) => null;

export default StepperItem;
